import { Chips, ChipsProps } from 'primereact/chips';

import './style.css';

interface ICustomChips extends ChipsProps {
    label?: string;
    labelStyle?: React.CSSProperties;
    error?: string | null;
}

const CustomChips: React.FC<ICustomChips> = ({
    label,
    name,
    labelStyle,
    error,
    ...rest
}) => {
    return (
        <div className='custom-input-text'>
            <span>
                <label
                    htmlFor={name}
                    style={{
                        marginRight: '8px',
                        display : label ? 'inherit' : 'none',
                        ...labelStyle,
                    }}
                >
                    {label}
                </label>
                <Chips {...rest} />
                {error && (
                    <small
                        id={`${name}-help`}
                        className='p-error block input-text-error'
                    >
                        {error}
                    </small>
                )}
            </span>
        </div>
    );
};

export default CustomChips;
